// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {

    async getSystem({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/systems/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },   
    
    async getSystemsBySite({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/systems/by-site/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    async getSystemsBySiteIds({ commit, state, rootState, rootGetters }, payload) {
        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        let data ={
            site_ids : payload
        }

        try {
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/systems/by-site-ids`, data, config);
            commit('updateSystemList', response.data)
            return response.data;
        } catch (error) {
            return error;
        }
    },


    async getSystems({ commit, state, rootState, rootGetters }, { id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = rootGetters.access_token;


            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/systems`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {

            if (error.status === 401) {

            }

            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async saveCurrentSystemFilter({commit}, system){
        localStorage.setItem('currentSystem', JSON.stringify(system))
        commit('updateCurrentSystem', system)
    },
    async getCurrentSystemFilter({commit}){
        let system = localStorage.getItem('currentSystem')
        if(system){
            system = JSON.parse(system)
            commit('updateCurrentSystem', system)
        }
    },

    async createSystem({ commit, state, rootState, rootGetters }, payload) {

        const access_token = rootGetters.access_token;

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/systems`,
                {
                    name: payload.name,
                    site_id: payload.site_id,
                    rhg_id: 1,
                    port: payload.port,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );


            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async updateSystems({ commit, state, rootState, rootGetters }, payload) {

        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/systems/${payload.id}`,
                {
                    name: payload.name,
                    site_id: payload.site_id,
                    port: payload.port,
                    rhg_id: 1,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    }


};
